import { render, staticRenderFns } from "./CompanyProject.vue?vue&type=template&id=d15f6a5e&scoped=true"
import script from "./CompanyProject.vue?vue&type=script&lang=js"
export * from "./CompanyProject.vue?vue&type=script&lang=js"
import style0 from "./CompanyProject.vue?vue&type=style&index=0&id=d15f6a5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15f6a5e",
  null
  
)

export default component.exports